export interface JwtPayload {
  sub: string
  email: string
  role: string
  permissions: string[]
  branchId?: string
  exp?: number
}

export function decodeToken(token: string): JwtPayload | null {
  try {
    const payload = token.split('.')[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded) as JwtPayload
  } catch {
    return null
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = decodeToken(token)
  if (!payload?.exp) return false
  return Date.now() / 1000 > payload.exp
}
